import api from './axios';

const BASE_URL = "/usuarios";

export const login = async ({ email, contrasena }) => {
    const { data } = await api.post(`${BASE_URL}/login`, { email, contrasena }, { _isLoginRequest: true });
    return data;
};

export const validarToken = async () => {
    const { data } = await api.get(`${BASE_URL}/auth/validar-token`, { _isLoginRequest: true });
    return data;
};

export const logout = async () => {
    const { data } = await api.post(`${BASE_URL}/logout`);
    return data;
};